import React from 'react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import gsap from 'gsap'
import { Tween } from 'react-gsap';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

var divice_width = window.innerWidth || document.documentElement.clientWidth;

function Users_Feedback() {


    return (

        <Tween
            to={{
                scrollTrigger: {
                    trigger: "#users_feedback",
                    start: '150px bottom',
                    end: 'bottom center',
                    scrub: true,
                    // markers: true
                },
                css: {
                    y: 50,
                    opacity : 1
                }
            }}
        >
            <section id="users_feedback">
                <div className="container">

                    <Tween
                        to={{
                            scrollTrigger: {
                                trigger: "#users_feedback .large-tittle",
                                start: '150px bottom',
                                // end: '250px center',
                                // scrub: true,
                                // markers: true
                            },
                            css: {
                                y: 0,
                                opacity : 1
                            }
                        }}
                    >
                        <div className="large-tittle">
                            <h1>Users Feedback</h1>
                            <span></span>
                            <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                                industry's.
                            </p>
                        </div>
                    </Tween>
                </div>

                <Tween
                    to={{
                        scrollTrigger: {
                            trigger: ".user-feedback-splide",
                            start: 'center center',
                            // end: '250px center',
                            // scrub: true,
                            // markers: true
                        },
                        css: {
                            y: 0,
                            opacity : 1
                        }
                    }}
                >
                    <div className="splide user-feedback-splide">
                            <Splide
                                options={{
                                    autoplay: true,
                                    interval: 4000,
                                    perPage : 4,
                                    autoHeight: divice_width > 1000 ? true : false,
                                    perMove: 1,
                                    type: 'loop',
                                    arrows: false,
                                    pagination: divice_width < 1000 ? true : false,
                                    breakpoints: {
                                        1540: {
                                            perPage: 3
                                        },
                                        1240: {
                                            perPage: 2
                                        },
                                        800: {
                                            perPage: 1
                                        },
                                    }
                                }}
                            
                            >

                                <User_feedback_card/>
                                <User_feedback_card/>
                                <User_feedback_card/>
                                <User_feedback_card/>
                                <User_feedback_card/>
                                <User_feedback_card/>
                                <User_feedback_card/>

                            </Splide>

                    </div>
                </Tween>
            </section>
        </Tween>
    )
}

export default Users_Feedback;





const User_feedback_card = () => (
    <SplideSlide>
        <div 
            className="user-feedback-card"
            style = {{
                top: divice_width < 1000 ? 0 : Math.floor(Math.random() * 200)
            }}
        >
            <div className="user-feedback-card-wrapper">
                <div className="user-feedback-img">
                    <img src="https://media.istockphoto.com/photos/studio-shot-of-a-handsome-and-happy-young-man-posing-against-a-grey-picture-id1355110818?b=1&k=20&m=1355110818&s=170667a&w=0&h=O58XhltYuAw0ssiUWXAFlIitq_4kj-WdJFWcTLEoUi0="
                        alt=""/>
                </div>

                <h1>John C. Arana</h1>
                <i className="fa-solid fa-quote-right"></i>
                <p>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolore, nam. Illo adipisci
                    vitae
                    fugit, quibusdam earum ipsa enim fuga, sunt voluptas necessitatibus officia error,
                    iste at eos
                    aperiam recusandae cum.
                </p>
            </div>
        </div>
    </SplideSlide>
)